import { useAuth } from '../contexts/AuthContext';

/**
 * AuthGuard Component
 *
 * Wraps your app and shows loading screen while validating authentication.
 * Automatically redirects to portal if not authenticated.
 *
 * Usage in App.tsx:
 *   <AuthProvider>
 *     <AuthGuard>
 *       <YourApp />
 *     </AuthGuard>
 *   </AuthProvider>
 */
export function AuthGuard({ children }: { children: React.ReactNode }) {
  const { isLoading, isAuthenticated } = useAuth();

  // Show loading screen while validating token
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Validando autenticación...</p>
          <p className="text-gray-400 text-sm mt-2">Conectando con Terralink Portal</p>
        </div>
      </div>
    );
  }

  // If not authenticated, AuthProvider will redirect
  if (!isAuthenticated) {
    return null;
  }

  // User is authenticated, show app
  return <>{children}</>;
}
